module.exports = __webpack_public_path__ + "static/media/webdesign.43920812.svg";